import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SalesOrderConfig } from 'v2/modules/sales-order/configs/sales-order.config';

@Component({
  selector: 'lum-order-ordered-items-table',
  templateUrl: './order-ordered-items-table.component.html',
  styleUrls: ['./order-ordered-items-table.component.scss'],
})
export class OrderOrderedItemsTableComponent implements OnChanges {
  @Input() orderItems :any[];

  hasLineWithCustomFields = false;
  areAllExpanded = false;

  readonly lineItemStatusKeyLabel = SalesOrderConfig.lineItemStatusKeyLabel;

  constructor() {}

  ngOnChanges(changes :SimpleChanges) {
    if (changes['orderItems']) {
      this.hasLineWithCustomFields = this.orderItems?.some?.(
        (item) => (item.customFieldValues?.length ?? 0) > 0,
      );
    }
  }

  onToggleExpand(item :any) {
    item.isExpanded = !item.isExpanded;

    this.areAllExpanded = this.orderItems.every((item) => item.isExpanded);
  }

  onToggleExpandAll() {
    this.areAllExpanded = !this.areAllExpanded;
    this.orderItems.forEach((item) => {
      item.isExpanded = this.areAllExpanded;
    });
  }
}
